import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
  TextField,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
  FormHelperTextProps,
  Button,
} from '@material-ui/core';
import { isNull, startCase } from 'lodash';
import React, { Fragment, useEffect, useCallback, memo, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { amber, red, blue, teal } from '@material-ui/core/colors';
import { ContentMedia, MediaType, VideoSite, VideoType } from '@lib/content';
import { usePintMaster } from '@lib/common';
type EnumObject = { label: React.ReactNode; value: any };
type EnumMap = EnumObject[];
import { camelCase } from 'lodash';
import { Autocomplete } from '@material-ui/lab';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { Card, CardContent, Grid, Box } from '@material-ui/core';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import UploadFileIcon from '@material-ui/icons/InsertDriveFile';
export const createEnumMap = (enum_: Record<string, any>, retainSpecialChars = true): EnumMap =>
  Object.values(enum_).map(value => ({
    label: retainSpecialChars ? value : startCase(camelCase(value)),
    value,
  }));
import { useFormContext } from 'react-hook-form';
const VideoSiteOptions = createEnumMap(VideoSite);
const VideoTypeOptions = createEnumMap(VideoType);
import { CompanyLogoField } from '../fields/upload-file.field';
import { ServicesField } from './company-services'
import { ProjectsField } from './company-projects';
import { useSnackbar } from 'notistack';
// import { CompanyBasicFormField, CompanyLogoField } from '../fields';
export const MediaDialogContent = memo<any>(
  ({ saveMedia, defaultValue, OkPressed, setOkPressed, company_services = null, company_vtr_id=null}) => {

    const [caption, setCaption] = useState(defaultValue ? defaultValue.media_title : null);
    const [associatedServices, setAssociatedServices] = useState(defaultValue ? defaultValue.associated_services : []);
    const [media_url, setMediaUrl] = useState(defaultValue ? defaultValue.media_url : null);
    const [media_type, setMediaType] = useState(defaultValue ? defaultValue.media_type : null);
    const [associatedProjects, setAssociatedProjects] = useState(defaultValue ? defaultValue.associated_projects : []);
    // const [language_id, setLanguageId] = useState(defaultValue ? defaultValue.language_id : null);
    const [vtrId, setVtrId] = useState(defaultValue ? defaultValue.vtr_id : null);
    const [touched, setTouched] = useState<Boolean>(false);
    const [file, setFile] = React.useState(null)
    const [attach_b64, setAttachB64] = React.useState(null)
    const [filename, setFileName] = React.useState(null)
    const [showImage, setShowImage] = React.useState(defaultValue?.media_type == 'video' ? false : true)
 

    const convertBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
     
        // return fileReader.result
        
        fileReader.onload = () => {
          resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
          reject(error);
        }
      })
    }

    const fileHandler = async(e) => {
        const media_ext = e.target.files[0]['type']
        if(media_ext.includes('image')){
          setMediaType('image');
        }
        else{
          setMediaType('pdf');
        }
        setFile(e.target.files[0])
        setFileName(e.target.files[0]['name'])
        var reader = new FileReader();
        const file_input = e.target.files[0]
        const base64 = await convertBase64(file_input)
  
        if(base64 != null){
          setAttachB64((base64 as string).split(',')[1])
        }
       
    }
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   
    useEffect(() => {
      if (OkPressed) {
      
        // const saveMediaDetails = {
        //   file_name: (defaultValue?.file_name) ? defaultValue?.file_name : filename,
        //   associated_services: associatedServices,
        //   media_url: media_url,
        //   associated_projects: associatedProjects,
        //   caption: caption,
        //   attach_b64: attach_b64,
        //   media_caption: (defaultValue?.caption) ? defaultValue?.caption : caption,
        //   media_title: (defaultValue?.caption) ? defaultValue?.caption : caption,
        //   media_type: (!showImage) ? 'video' : media_type,
        //   original_media_vtr_id: (defaultValue?.original_media_vtr_id) ? defaultValue?.original_media_vtr_id : null,
        //   ...(vtrId ? { vtr_id: vtrId } : null),
        // };
        const saveMediaDetails = {
          file_name: filename ? filename : defaultValue?.file_name,
          associated_services: associatedServices,
          media_url: media_url,
          associated_projects: associatedProjects,
          caption: caption,
          attach_b64: attach_b64 != null ? attach_b64 : (defaultValue?.attach_b64),
          media_caption: caption,
          media_title: caption,
          media_type: (!showImage) ? 'video' : media_type,
          original_media_vtr_id: (defaultValue?.original_media_vtr_id) ? defaultValue?.original_media_vtr_id : null,
          ...(vtrId ? { vtr_id: vtrId } : null),
        };
     
        if ((defaultValue?.caption || caption) && ((defaultValue?.file_name || filename) || (defaultValue?.media_url || media_url)))
        {
          saveMedia(saveMediaDetails);
       
        }else{
          enqueueSnackbar(`Media Caption & File are mandatory to add an media`, { variant: 'error' });
        }
        setOkPressed(false);
      }
    }, [OkPressed]);
  
    const { control } = useFormContext();

    const setServices = (ser) => {
  
      setAssociatedServices(ser)
    }
    const setProjects = (ser) => {
  
      setAssociatedProjects(ser)
    }
    return (
      <>
        {/* <Typography variant="subtitle1">Video Name</Typography> */}
        <br />
        <Box p={1} style={{ background: '#f5f5f5' }}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Card
              style={{"cursor":"pointer", "backgroundColor": (showImage ? "#388e3c" : '#fff')}}
              onClick={()=>setShowImage(true)}
              // onClick={onChange && (() => onChange(ContentType.SERIES))}
              >
                {/* {clsx('card-button tv', { selected: value === ContentType.SERIES })}> */}
                <CardContent>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <UploadFileIcon style={{ fontSize: '2.5rem' }} />
                    </Grid>
                    <Grid item>
                      <Typography className="title" variant="h6">
                        PDF / Image
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card
              style={{"cursor":"pointer", "backgroundColor": (!showImage ? "#388e3c" : '#fff')}}
              onClick={()=>setShowImage(false)}
              // onClick={onChange && (() => onChange(ContentType.SERIES))}
              >
                {/* {clsx('card-button tv', { selected: value === ContentType.SERIES })}> */}
                <CardContent>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <OndemandVideoIcon style={{ fontSize: '2.5rem' }} />
                    </Grid>
                    <Grid item>
                      <Typography className="title" variant="h6">
                        Video
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>


        </Box>
        <div>
          <br />
        <div hidden={!showImage}>
        
            {/* <img src={defaultValue.media_path} alt={defaultValue.media_caption}/> */}
            {(defaultValue?.media_type == 'pdf' && !file) ? 
            <div><embed src={defaultValue.media_url} width="100px" height="100px" /></div>
            : ''}
            {(defaultValue?.media_type == 'image' && !file) ? 
            <div><embed src={defaultValue.media_url} width="100px" height="100px" /></div>
            : ''}

            

            {(file) ? <div>
              
              {(media_type == 'image')?<img height="100px" width="100px" src={"data:image/png;base64,"+attach_b64} alt={file? file.name : null}/>
              :  
              // <img height="100px" width="100px" src={file? URL.createObjectURL(file) : null} alt={file? file.name : null}/>
                <embed height="100px" width="100px" src={"data:application/pdf;base64,"+attach_b64}></embed>
            }
              
              </div> : ''}

              {(defaultValue?.attach_b64 != null) ? <div>
              
              {(defaultValue?.media_type == 'image')?<img height="100px" width="100px" src={"data:image/png;base64,"+defaultValue?.attach_b64} alt={defaultValue.file_name ?  defaultValue.file_name : null}/>
              :  
              // <img height="100px" width="100px" src={file? URL.createObjectURL(file) : null} alt={file? file.name : null}/>
                <embed height="100px" width="100px" src={"data:application/pdf;base64,"+defaultValue?.attach_b64}></embed>
            }
              
              </div> : ''}
              
              <Button variant="contained" component="label">
              Upload Image/PDF File
              <input hidden type="file" accept="application/pdf,image/*" onChange={fileHandler} />
              {/* <input hidden accept="image/*" multiple type="file" /> */}
            </Button>
            
        </div>
         <br />
        </div>
        <div hidden={showImage}>
        {/* <ControlledTextField
          
          fullWidth
          variant="outlined"
          value={media_url}
          setValue={setMediaUrl}
          setTouched={setTouched}
          touched={touched}
          label={'Media URL'}
        /> */}

        <TextField
          fullWidth
          variant="outlined"
          value={media_url ? media_url : ""}
          // setValue={setCaption}
          // setTouched={setTouched}
          onChange={(e) => setMediaUrl(e.target.value)}
          // touched={touched}
          label={'Media Url'}
          name={'media_url'}

        />
        </div>
        <br />
        {/* <Typography variant="subtitle1">Video Site</Typography> */}
        <br />
        <TextField
          fullWidth
          variant="outlined"
          value={caption ? caption : ""}
          // setValue={setCaption}
          // setTouched={setTouched}
          onChange={(e) => setCaption(e.target.value)}
          // touched={touched}
          label={'Caption'}
          name={'caption'}

        />
        <br />
        {/* <Typography variant="subtitle1">Video Site</Typography> */}
        <br />
        {/* <ServicesField services={company_services} selected_services={defaultValue?.associated_services} setServices={setServices} control={control} name="associated_services" /> */}

        {/* <Typography variant="subtitle1">Video Path</Typography> */}
        <br />
        {/* <ProjectsField control={control} company_vtr_id={company_vtr_id}  name="associated_projects" setProjects={setProjects} selected_projects={defaultValue?.associated_projects}/> */}
        

      </>
    );
  }
);

const ControlledTextField = ({ value, setValue, label, touched, setTouched, ...props }) => {
  const callbackOnChange = useCallback(e => setValue(e.target.value), []);
  return (
    <>
      <TextField
        {...props}
        value={value}
        label={label}
        size={'medium'}
        onChange={callbackOnChange}
        
        onFocus={evt => setTouched(true)}
      />
      {!(touched && !value) ? (
        <>
          <br />
        </>
      ) : (
        <>
          <br />
        </>
      )}
    </>
  );
};

const CountryStyles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;


